module.exports = __webpack_public_path__ + "media/images/redesign-images/ma/profile-images/christa-santoro-fa017d5a49c4aafe4d31a86856606ded.jpg";